import { render } from "./VerifyAccount.vue?vue&type=template&id=8f4962de&scoped=true"
import script from "./VerifyAccount.vue?vue&type=script&lang=js"
export * from "./VerifyAccount.vue?vue&type=script&lang=js"

import "./VerifyAccount.vue?vue&type=style&index=0&id=8f4962de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f4962de"]])

export default __exports__